import { Controller } from "@hotwired/stimulus"

// Handles explicit "Clear description" action in card forms.
// Sets a hidden flag so the server knows the blank submission is intentional.
export default class extends Controller {
  static targets = ["flag", "editor", "trigger"]

  clear() {
    this.flagTarget.value = "1"
    const editor = this.editorTarget.querySelector("lexxy-editor")
    if (editor) editor.value = ""
    if (this.hasTriggerTarget) this.triggerTarget.remove()
  }
}
